"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAssessmentCurrency = exports.IAssessmentEvent = void 0;
var IAssessmentEvent;
(function (IAssessmentEvent) {
    IAssessmentEvent[IAssessmentEvent["DAYS_1"] = 1] = "DAYS_1";
    IAssessmentEvent[IAssessmentEvent["WEEKS_2"] = 2] = "WEEKS_2";
    IAssessmentEvent[IAssessmentEvent["MONTHS_3"] = 3] = "MONTHS_3";
    IAssessmentEvent[IAssessmentEvent["YEARS_4"] = 4] = "YEARS_4";
    IAssessmentEvent[IAssessmentEvent["SINGLE_5"] = 5] = "SINGLE_5";
    IAssessmentEvent[IAssessmentEvent["AUTH_6"] = 6] = "AUTH_6";
    IAssessmentEvent[IAssessmentEvent["CAPTURE_7"] = 7] = "CAPTURE_7";
    IAssessmentEvent[IAssessmentEvent["REFUND_8"] = 8] = "REFUND_8";
    IAssessmentEvent[IAssessmentEvent["BOARD_9"] = 9] = "BOARD_9";
    IAssessmentEvent[IAssessmentEvent["PAYOUT_10"] = 10] = "PAYOUT_10";
    IAssessmentEvent[IAssessmentEvent["CHARGEBACK_11"] = 11] = "CHARGEBACK_11";
    IAssessmentEvent[IAssessmentEvent["OVERDRAFT_12"] = 12] = "OVERDRAFT_12";
    IAssessmentEvent[IAssessmentEvent["INTERCHANGE_13"] = 13] = "INTERCHANGE_13";
    IAssessmentEvent[IAssessmentEvent["PROCESSOR_14"] = 14] = "PROCESSOR_14";
    IAssessmentEvent[IAssessmentEvent["ACHFAIL_15"] = 15] = "ACHFAIL_15";
    IAssessmentEvent[IAssessmentEvent["ACCOUNT_16"] = 16] = "ACCOUNT_16";
    IAssessmentEvent[IAssessmentEvent["SIFT_17"] = 17] = "SIFT_17";
    IAssessmentEvent[IAssessmentEvent["ADJUSTMENT_18"] = 18] = "ADJUSTMENT_18";
    IAssessmentEvent[IAssessmentEvent["RETRIEVAL_19"] = 19] = "RETRIEVAL_19";
    IAssessmentEvent[IAssessmentEvent["ARBITRATION_20"] = 20] = "ARBITRATION_20";
    IAssessmentEvent[IAssessmentEvent["ECSALE_21"] = 21] = "ECSALE_21";
    IAssessmentEvent[IAssessmentEvent["ECREFUND_22"] = 22] = "ECREFUND_22";
    IAssessmentEvent[IAssessmentEvent["ECRETURN_23"] = 23] = "ECRETURN_23";
    IAssessmentEvent[IAssessmentEvent["SETTLEMENT_24"] = 24] = "SETTLEMENT_24";
    IAssessmentEvent[IAssessmentEvent["MISUSE_25"] = 25] = "MISUSE_25";
    IAssessmentEvent[IAssessmentEvent["PROFIT_SHARE_26"] = 26] = "PROFIT_SHARE_26";
    IAssessmentEvent[IAssessmentEvent["UNAUTH_27"] = 27] = "UNAUTH_27";
    IAssessmentEvent[IAssessmentEvent["ACHNOC_28"] = 28] = "ACHNOC_28";
    IAssessmentEvent[IAssessmentEvent["ECNOC_29"] = 29] = "ECNOC_29";
    IAssessmentEvent[IAssessmentEvent["ECFAIL_30"] = 30] = "ECFAIL_30";
    IAssessmentEvent[IAssessmentEvent["ECNSF_31"] = 31] = "ECNSF_31";
    IAssessmentEvent[IAssessmentEvent["CURRENCY_CONVERSION_32"] = 32] = "CURRENCY_CONVERSION_32";
    IAssessmentEvent[IAssessmentEvent["TERMINAL_TXN_33"] = 33] = "TERMINAL_TXN_33";
    IAssessmentEvent[IAssessmentEvent["REVERSE_PAYOUT_34"] = 34] = "REVERSE_PAYOUT_34";
    IAssessmentEvent[IAssessmentEvent["PARTIAL_REVERSE_PAYOUT_35"] = 35] = "PARTIAL_REVERSE_PAYOUT_35";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_43"] = 43] = "DEFAULT_43";
    IAssessmentEvent[IAssessmentEvent["PAYMENT_UPDATE_44"] = 44] = "PAYMENT_UPDATE_44";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_45"] = 45] = "DEFAULT_45";
    IAssessmentEvent[IAssessmentEvent["PAYMENT_GROUP_UPDATE_46"] = 46] = "PAYMENT_GROUP_UPDATE_46";
    IAssessmentEvent[IAssessmentEvent["ENTRY_REFUND_47"] = 47] = "ENTRY_REFUND_47";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_51"] = 51] = "DEFAULT_51";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_52"] = 52] = "DEFAULT_52";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_53"] = 53] = "DEFAULT_53";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_54"] = 54] = "DEFAULT_54";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_55"] = 55] = "DEFAULT_55";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_56"] = 56] = "DEFAULT_56";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_57"] = 57] = "DEFAULT_57";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_58"] = 58] = "DEFAULT_58";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_59"] = 59] = "DEFAULT_59";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_60"] = 60] = "DEFAULT_60";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_61"] = 61] = "DEFAULT_61";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_62"] = 62] = "DEFAULT_62";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_63"] = 63] = "DEFAULT_63";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_64"] = 64] = "DEFAULT_64";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_65"] = 65] = "DEFAULT_65";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_66"] = 66] = "DEFAULT_66";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_67"] = 67] = "DEFAULT_67";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_68"] = 68] = "DEFAULT_68";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_69"] = 69] = "DEFAULT_69";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_70"] = 70] = "DEFAULT_70";
    IAssessmentEvent[IAssessmentEvent["DEFAULT_71"] = 71] = "DEFAULT_71";
})(IAssessmentEvent = exports.IAssessmentEvent || (exports.IAssessmentEvent = {}));
var IAssessmentCurrency;
(function (IAssessmentCurrency) {
    IAssessmentCurrency["UNITED_ARAB_EMIRATES_DIRHAM_AED"] = "AED";
    IAssessmentCurrency["AFGHAN_AFGHANI_AFN"] = "AFN";
    IAssessmentCurrency["ALBANIAN_LEK_ALL"] = "ALL";
    IAssessmentCurrency["ARMENIAN_DRAM_AMD"] = "AMD";
    IAssessmentCurrency["NETHERLANDS_ANTILLEAN_GUILDER_ANG"] = "ANG";
    IAssessmentCurrency["ANGOLAN_KWANZA_AOA"] = "AOA";
    IAssessmentCurrency["ARGENTINE_PESO_ARS"] = "ARS";
    IAssessmentCurrency["AUSTRALIAN_DOLLAR_AUD"] = "AUD";
    IAssessmentCurrency["ARUBAN_FLORIN_AWG"] = "AWG";
    IAssessmentCurrency["AZERBAIJANI_MANAT_AZN"] = "AZN";
    IAssessmentCurrency["BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK_BAM"] = "BAM";
    IAssessmentCurrency["BARBADOS_DOLLAR_BBD"] = "BBD";
    IAssessmentCurrency["BANGLADESHI_TAKA_BDT"] = "BDT";
    IAssessmentCurrency["BULGARIAN_LEV_BGN"] = "BGN";
    IAssessmentCurrency["BAHRAINI_DINAR_BHD"] = "BHD";
    IAssessmentCurrency["BURUNDIAN_FRANC_BIF"] = "BIF";
    IAssessmentCurrency["BERMUDIAN_DOLLAR_BMD"] = "BMD";
    IAssessmentCurrency["BRUNEI_DOLLAR_BND"] = "BND";
    IAssessmentCurrency["BOLIVIANO_BOB"] = "BOB";
    IAssessmentCurrency["BOLIVIAN_MVDOL_BOV"] = "BOV";
    IAssessmentCurrency["BRAZILIAN_REAL_BRL"] = "BRL";
    IAssessmentCurrency["BAHAMIAN_DOLLAR_BSD"] = "BSD";
    IAssessmentCurrency["BHUTANESE_NGULTRUM_BTN"] = "BTN";
    IAssessmentCurrency["BOTSWANA_PULA_BWP"] = "BWP";
    IAssessmentCurrency["BELARUSIAN_RUBLE_BYN"] = "BYN";
    IAssessmentCurrency["BELIZE_DOLLAR_BZD"] = "BZD";
    IAssessmentCurrency["CANADIAN_DOLLAR_CAD"] = "CAD";
    IAssessmentCurrency["CONGOLESE_FRANC_CDF"] = "CDF";
    IAssessmentCurrency["WIR_EURO_CHE"] = "CHE";
    IAssessmentCurrency["SWISS_FRANC_CHF"] = "CHF";
    IAssessmentCurrency["WIR_FRANC_CHW"] = "CHW";
    IAssessmentCurrency["UNIDAD_DE_FOMENTO_CLF"] = "CLF";
    IAssessmentCurrency["CHILEAN_PESO_CLP"] = "CLP";
    IAssessmentCurrency["RENMINBI_CHINESE_YUAN_CNY"] = "CNY";
    IAssessmentCurrency["COLOMBIAN_PESO_COP"] = "COP";
    IAssessmentCurrency["UNIDAD_DE_VALOR_REAL_COU"] = "COU";
    IAssessmentCurrency["COSTA_RICAN_COLON_CRC"] = "CRC";
    IAssessmentCurrency["CUBAN_CONVERTIBLE_PESO_CUC"] = "CUC";
    IAssessmentCurrency["CUBAN_PESO_CUP"] = "CUP";
    IAssessmentCurrency["CAPE_VERDE_ESCUDO_CVE"] = "CVE";
    IAssessmentCurrency["CZECH_KORUNA_CZK"] = "CZK";
    IAssessmentCurrency["DJIBOUTIAN_FRANC_DJF"] = "DJF";
    IAssessmentCurrency["DANISH_KRONE_DKK"] = "DKK";
    IAssessmentCurrency["DOMINICAN_PESO_DOP"] = "DOP";
    IAssessmentCurrency["ALGERIAN_DINAR_DZD"] = "DZD";
    IAssessmentCurrency["EGYPTIAN_POUND_EGP"] = "EGP";
    IAssessmentCurrency["ERITREAN_NAKFA_ERN"] = "ERN";
    IAssessmentCurrency["ETHIOPIAN_BIRR_ETB"] = "ETB";
    IAssessmentCurrency["EURO_EUR"] = "EUR";
    IAssessmentCurrency["FIJI_DOLLAR_FJD"] = "FJD";
    IAssessmentCurrency["FALKLAND_ISLANDS_POUND_FKP"] = "FKP";
    IAssessmentCurrency["POUND_STERLING_GBP"] = "GBP";
    IAssessmentCurrency["GEORGIAN_LARI_GEL"] = "GEL";
    IAssessmentCurrency["GHANAIAN_CEDI_GHS"] = "GHS";
    IAssessmentCurrency["GIBRALTAR_POUND_GIP"] = "GIP";
    IAssessmentCurrency["GAMBIAN_DALASI_GMD"] = "GMD";
    IAssessmentCurrency["GUINEAN_FRANC_GNF"] = "GNF";
    IAssessmentCurrency["GUATEMALAN_QUETZAL_GTQ"] = "GTQ";
    IAssessmentCurrency["GUYANESE_DOLLAR_GYD"] = "GYD";
    IAssessmentCurrency["HONG_KONG_DOLLAR_HKD"] = "HKD";
    IAssessmentCurrency["HONDURAN_LEMPIRA_HNL"] = "HNL";
    IAssessmentCurrency["CROATIAN_KUNA_HRK"] = "HRK";
    IAssessmentCurrency["HAITIAN_GOURDE_HTG"] = "HTG";
    IAssessmentCurrency["HUNGARIAN_FORINT_HUF"] = "HUF";
    IAssessmentCurrency["INDONESIAN_RUPIAH_IDR"] = "IDR";
    IAssessmentCurrency["ISRAELI_NEW_SHEKEL_ILS"] = "ILS";
    IAssessmentCurrency["INDIAN_RUPEE_INR"] = "INR";
    IAssessmentCurrency["IRAQI_DINAR_IQD"] = "IQD";
    IAssessmentCurrency["IRANIAN_RIAL_IRR"] = "IRR";
    IAssessmentCurrency["ICELANDIC_KRNA_ISK"] = "ISK";
    IAssessmentCurrency["JAMAICAN_DOLLAR_JMD"] = "JMD";
    IAssessmentCurrency["JORDANIAN_DINAR_JOD"] = "JOD";
    IAssessmentCurrency["JAPANESE_YEN_JPY"] = "JPY";
    IAssessmentCurrency["KENYAN_SHILLING_KES"] = "KES";
    IAssessmentCurrency["KYRGYZSTANI_SOM_KGS"] = "KGS";
    IAssessmentCurrency["CAMBODIAN_RIEL_KHR"] = "KHR";
    IAssessmentCurrency["COMORO_FRANC_KMF"] = "KMF";
    IAssessmentCurrency["NORTH_KOREAN_WON_KPW"] = "KPW";
    IAssessmentCurrency["SOUTH_KOREAN_WON_KRW"] = "KRW";
    IAssessmentCurrency["KUWAITI_DINAR_KWD"] = "KWD";
    IAssessmentCurrency["CAYMAN_ISLANDS_DOLLAR_KYD"] = "KYD";
    IAssessmentCurrency["KAZAKHSTANI_TENGE_KZT"] = "KZT";
    IAssessmentCurrency["LAO_KIP_LAK"] = "LAK";
    IAssessmentCurrency["LEBANESE_POUND_LBP"] = "LBP";
    IAssessmentCurrency["SRI_LANKAN_RUPEE_LKR"] = "LKR";
    IAssessmentCurrency["LIBERIAN_DOLLAR_LRD"] = "LRD";
    IAssessmentCurrency["LESOTHO_LOTI_LSL"] = "LSL";
    IAssessmentCurrency["LIBYAN_DINAR_LYD"] = "LYD";
    IAssessmentCurrency["MOROCCAN_DIRHAM_MAD"] = "MAD";
    IAssessmentCurrency["MOLDOVAN_LEU_MDL"] = "MDL";
    IAssessmentCurrency["MALAGASY_ARIARY_MGA"] = "MGA";
    IAssessmentCurrency["MACEDONIAN_DENAR_MKD"] = "MKD";
    IAssessmentCurrency["MYANMAR_KYAT_MMK"] = "MMK";
    IAssessmentCurrency["MONGOLIAN_TGRG_MNT"] = "MNT";
    IAssessmentCurrency["MACANESE_PATACA_MOP"] = "MOP";
    IAssessmentCurrency["MAURITANIAN_OUGUIYA_MRU"] = "MRU";
    IAssessmentCurrency["MAURITIAN_RUPEE_MUR"] = "MUR";
    IAssessmentCurrency["MALDIVIAN_RUFIYAA_MVR"] = "MVR";
    IAssessmentCurrency["MALAWIAN_KWACHA_MWK"] = "MWK";
    IAssessmentCurrency["MEXICAN_PESO_MXN"] = "MXN";
    IAssessmentCurrency["MEXICAN_UNIDAD_DE_INVERSION_MXV"] = "MXV";
    IAssessmentCurrency["MALAYSIAN_RINGGIT_MYR"] = "MYR";
    IAssessmentCurrency["MOZAMBICAN_METICAL_MZN"] = "MZN";
    IAssessmentCurrency["NAMIBIAN_DOLLAR_NAD"] = "NAD";
    IAssessmentCurrency["NIGERIAN_NAIRA_NGN"] = "NGN";
    IAssessmentCurrency["NICARAGUAN_CRDOBA_NIO"] = "NIO";
    IAssessmentCurrency["NORWEGIAN_KRONE_NOK"] = "NOK";
    IAssessmentCurrency["NEPALESE_RUPEE_NPR"] = "NPR";
    IAssessmentCurrency["NEW_ZEALAND_DOLLAR_NZD"] = "NZD";
    IAssessmentCurrency["OMANI_RIAL_OMR"] = "OMR";
    IAssessmentCurrency["PANAMANIAN_BALBOA_PAB"] = "PAB";
    IAssessmentCurrency["PERUVIAN_SOL_PEN"] = "PEN";
    IAssessmentCurrency["PAPUA_NEW_GUINEAN_KINA_PGK"] = "PGK";
    IAssessmentCurrency["PHILIPPINE_PISO_PHP"] = "PHP";
    IAssessmentCurrency["PAKISTANI_RUPEE_PKR"] = "PKR";
    IAssessmentCurrency["POLISH_ZOTY_PLN"] = "PLN";
    IAssessmentCurrency["PARAGUAYAN_GUARAN_PYG"] = "PYG";
    IAssessmentCurrency["QATARI_RIYAL_QAR"] = "QAR";
    IAssessmentCurrency["ROMANIAN_LEU_RON"] = "RON";
    IAssessmentCurrency["SERBIAN_DINAR_RSD"] = "RSD";
    IAssessmentCurrency["RUSSIAN_RUBLE_RUB"] = "RUB";
    IAssessmentCurrency["RWANDAN_FRANC_RWF"] = "RWF";
    IAssessmentCurrency["SAUDI_RIYAL_SAR"] = "SAR";
    IAssessmentCurrency["SOLOMON_ISLANDS_DOLLAR_SBD"] = "SBD";
    IAssessmentCurrency["SEYCHELLES_RUPEE_SCR"] = "SCR";
    IAssessmentCurrency["SUDANESE_POUND_SDG"] = "SDG";
    IAssessmentCurrency["SWEDISH_KRONAKRONOR_SEK"] = "SEK";
    IAssessmentCurrency["SINGAPORE_DOLLAR_SGD"] = "SGD";
    IAssessmentCurrency["SAINT_HELENA_POUND_SHP"] = "SHP";
    IAssessmentCurrency["SIERRA_LEONEAN_LEONE_SLL"] = "SLL";
    IAssessmentCurrency["SOMALI_SHILLING_SOS"] = "SOS";
    IAssessmentCurrency["SURINAMESE_DOLLAR_SRD"] = "SRD";
    IAssessmentCurrency["SOUTH_SUDANESE_POUND_SSP"] = "SSP";
    IAssessmentCurrency["SO_TOM_AND_PRNCIPE_DOBRA_STN"] = "STN";
    IAssessmentCurrency["SALVADORAN_COLN_SVC"] = "SVC";
    IAssessmentCurrency["SYRIAN_POUND_SYP"] = "SYP";
    IAssessmentCurrency["SWAZI_LILANGENI_SZL"] = "SZL";
    IAssessmentCurrency["THAI_BAHT_THB"] = "THB";
    IAssessmentCurrency["TAJIKISTANI_SOMONI_TJS"] = "TJS";
    IAssessmentCurrency["TURKMENISTAN_MANAT_TMT"] = "TMT";
    IAssessmentCurrency["TUNISIAN_DINAR_TND"] = "TND";
    IAssessmentCurrency["TONGAN_PAANGA_TOP"] = "TOP";
    IAssessmentCurrency["TURKISH_LIRA_TRY"] = "TRY";
    IAssessmentCurrency["TRINIDAD_AND_TOBAGO_DOLLAR_TTD"] = "TTD";
    IAssessmentCurrency["NEW_TAIWAN_DOLLAR_TWD"] = "TWD";
    IAssessmentCurrency["TANZANIAN_SHILLING_TZS"] = "TZS";
    IAssessmentCurrency["UKRAINIAN_HRYVNIA_UAH"] = "UAH";
    IAssessmentCurrency["UGANDAN_SHILLING_UGX"] = "UGX";
    IAssessmentCurrency["UNITED_STATES_DOLLAR_USD"] = "USD";
    IAssessmentCurrency["UNITED_STATES_DOLLAR_USN"] = "USN";
    IAssessmentCurrency["URUGUAY_PESO_EN_UNIDADES_INDEXADAS_UYI"] = "UYI";
    IAssessmentCurrency["URUGUAYAN_PESO_UYU"] = "UYU";
    IAssessmentCurrency["UZBEKISTAN_SOM_UZS"] = "UZS";
    IAssessmentCurrency["VENEZUELAN_BOLVAR_VEF"] = "VEF";
    IAssessmentCurrency["VIETNAMESE_NG_VND"] = "VND";
    IAssessmentCurrency["VANUATU_VATU_VUV"] = "VUV";
    IAssessmentCurrency["SAMOAN_TALA_WST"] = "WST";
    IAssessmentCurrency["CFA_FRANC_BEAC_XAF"] = "XAF";
    IAssessmentCurrency["SILVER_XAG"] = "XAG";
    IAssessmentCurrency["GOLD_XAU"] = "XAU";
    IAssessmentCurrency["EUROPEAN_COMPOSITE_UNIT_XBA"] = "XBA";
    IAssessmentCurrency["EUROPEAN_MONETARY_UNIT_XBB"] = "XBB";
    IAssessmentCurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBC"] = "XBC";
    IAssessmentCurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBD"] = "XBD";
    IAssessmentCurrency["EAST_CARIBBEAN_DOLLAR_XCD"] = "XCD";
    IAssessmentCurrency["SPECIAL_DRAWING_RIGHTS_XDR"] = "XDR";
    IAssessmentCurrency["CFA_FRANC_BCEAO_XOF"] = "XOF";
    IAssessmentCurrency["PALLADIUM_XPD"] = "XPD";
    IAssessmentCurrency["CFP_FRANC_XPF"] = "XPF";
    IAssessmentCurrency["PLATINUM_XPT"] = "XPT";
    IAssessmentCurrency["SUCRE_XSU"] = "XSU";
    IAssessmentCurrency["ADB_UNIT_OF_ACCOUNT_XUA"] = "XUA";
    IAssessmentCurrency["YEMENI_RIAL_YER"] = "YER";
    IAssessmentCurrency["SOUTH_AFRICAN_RAND_ZAR"] = "ZAR";
    IAssessmentCurrency["ZAMBIAN_KWACHA_ZMW"] = "ZMW";
    IAssessmentCurrency["ZIMBABWEAN_DOLLAR_ZWL"] = "ZWL";
})(IAssessmentCurrency = exports.IAssessmentCurrency || (exports.IAssessmentCurrency = {}));
